import { FlowFormData, FlowInstanceCreatePayload, FlowMappingsData } from './types';

export const buildFlowParamsPayload = (flowParams: FlowFormData): FlowInstanceCreatePayload['params'] => {
  return Object.entries(flowParams).map(([key, value]) => ({
    key,
    value,
  }));
};

export const buildFlowMappingsPayload = (flowMappings: FlowMappingsData): FlowInstanceCreatePayload['mappings'] => {
  return Object.entries(flowMappings).map(([source, target]) => ({
    source,
    target: String(target),
  }));
};

type BuildFlowInstancePayloadArgs = {
  workspaceId: string;
  connectorFlowId: string;
  connectorInstanceId: string;
  audienceId: string;
  flowParams: FlowFormData;
  flowMappings: FlowMappingsData;
};

export const buildFlowInstancePayload = ({
  workspaceId,
  connectorFlowId,
  connectorInstanceId,
  audienceId,
  flowParams,
  flowMappings,
}: BuildFlowInstancePayloadArgs): FlowInstanceCreatePayload => ({
  workspaceId,
  id: connectorFlowId,
  connectorInstanceId,
  audienceId,
  params: buildFlowParamsPayload(flowParams),
  mappings: buildFlowMappingsPayload(flowMappings),
  sendNow: false,
});
